<template>
  <div class="weatherWeibo">
    <iframe
      src="https://m.weibo.cn/u/2294193132"
      frameborder="0"
      class="iframeWeibo"
    ></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.iframeWeibo {
  width: 100%;
  height: 350px;
}
</style>
